import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";

export class FulfillmentEditStepsPriceDialogViewComponent implements IController {
  fulfillment: any;
  priceInfo: any;
  onResetToDefault: Function;
  onChangeStepPrice: Function;

  public locationTypes: typeof LocationType = LocationType;
  public currencyUnit: string;
  public fulfillmentStepsInfo: any = {};
  public fulfillmentStepPrice: any = {};
  public totalPercentageOfSteps: number = 0;

  constructor(private splitService) {
  }

  $onInit() {
    this.currencyUnit = this.splitService.getCurrencySymbol();

    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      this.fulfillmentStepsInfo[step.id] = step
    })
    this._stepPricePercentageToPrice();
    this._totalPercentageOfSteps();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.priceInfo && !changes.priceInfo.isFirstChange()) {
      this._stepPricePercentageToPrice();
      this._totalPercentageOfSteps();
    }
  }

  onPricePercentageChange() {
    this._stepPricePercentageToPrice();
    this._totalPercentageOfSteps();
    this.onChangeStepPrice({priceInfo: this.priceInfo})
  }

  onChangePrice() {
    this._stepPriceToPercentage();
    this._totalPercentageOfSteps();
    this.onChangeStepPrice({priceInfo: this.priceInfo})
  }

  private _stepPricePercentageToPrice() {
    _.forEach(this.priceInfo.linesInfo, line => {
      _.forEach(line.steps, step => {
        if (!_.isNil(step.priceFactor)) {
          this.fulfillmentStepPrice[step.stepId] = (step.priceFactor * (line.linePrice || 0)) / 100;
        } else if (_.isUndefined(step.priceFactor)) { //in case it's a new order, no priceFactor. Dvirs bug
          this.fulfillmentStepPrice[step.stepId] = line.linePrice || 0;
          step.priceFactor = this.priceInfo.totalPrice ? (this.fulfillmentStepPrice[step.stepId] / this.priceInfo.totalPrice) * 100 : this.fulfillmentStepPrice[step.stepId] * 100;
        } else if (_.isNull(step.priceFactor)) { //in case it's a new order, no priceFactor. Dvirs bug
          this.fulfillmentStepPrice[step.stepId] = 0;
          step.priceFactor = 0;
        }
        step.priceFactor = _.toNumber(step.priceFactor.toFixed(2));
      })
    })
  }

  private _stepPriceToPercentage() {
    _.forEach(this.priceInfo.linesInfo, line => {
      _.forEach(line.steps, step => {
        if (this.fulfillmentStepPrice[step.stepId] > 0) {
          step.priceFactor = (this.fulfillmentStepPrice[step.stepId] / line.linePrice) * 100;
        } else {
          step.priceFactor = 0;
        }
        step.priceFactor = _.toNumber(step.priceFactor.toFixed(2));
      })
    })
  }

  private _totalPercentageOfSteps() {
    const steps = _.flatMap(this.priceInfo.linesInfo, 'steps');
    this.totalPercentageOfSteps = _.reduce(steps, (sum, step: any) => {
      return sum + (step.priceFactor);
    }, 0);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentEditStepsPriceDialogView', {
    bindings: {
      fulfillment: '<',
      priceInfo: '<',
      onResetToDefault: '&',
      onChangeStepPrice: '&'
    },
    template: require('./fulfillment-edit-steps-price-dialog-view.html').default,
    controller: FulfillmentEditStepsPriceDialogViewComponent
  });
